import React, { FC, useState, useEffect, useMemo, useCallback } from 'react'
import { cn } from 'shared/utils'

import { TSelectOption } from 'shared/types'
import { createCustomOption } from 'shared/utils/formatDate'
import { DateRangePicker, FilterRangeCustom } from '..'

import { FilterListProps } from './FilterList.props'
import './FilterList.scss'

const FilterList: FC<FilterListProps> = ({
  initialValue,
  onSelect,
  onReset,
  reset,
  options,
  customOption,
  defaultValue,
  disabled
}) => {
  const defaultOptionValue = options.find((option) => option.value === defaultValue)
  const initValue = useMemo(() => {
    if (customOption && initialValue.match(/from/)) {
      return createCustomOption(initialValue)
    }

    return options.find((option) => option.value === initialValue) || defaultOptionValue
  }, [customOption, initialValue, options, defaultOptionValue])

  const [currentValue, setCurrentValue] = useState<TSelectOption | undefined>(initValue)

  const selectValue = useCallback(
    (value: TSelectOption) => () => {
      setCurrentValue(value)
    },
    []
  )

  useEffect(() => {
    if (currentValue) {
      onSelect(currentValue.value, currentValue.type)
    }
  }, [currentValue, onSelect, initialValue])

  useEffect(() => {
    if (reset) {
      onReset()
      setCurrentValue(defaultOptionValue)
    }
  }, [reset, onReset, defaultOptionValue])

  return (
    <div
      className={cn('filter-list items-list', {
        'items-list--disabled': disabled
      })}
    >
      {options.map((option) => (
        <div
          className={cn('items-list__item', {
            'items-list__item--checked': option.value === currentValue?.value,
            'items-list__item--bold': option.title,
          })}
          onClick={selectValue(option)}
          key={option.value}
        >
          {option.label}{option.title ? <small> ({option.title})</small> : null}
        </div>
      ))}

      {customOption?.map(({ label, type }) => {
        if (type === 'week' || type === 'month' || type === 'range') {
          return (
            <DateRangePicker
              key={label}
              onSelect={selectValue}
              value={currentValue}
              type={type}
              {...(type === 'range' && { placeholder: label})}
            />
          )
        }
        return <FilterRangeCustom key={label} />
      })}
    </div>
  )
}

export default FilterList
